// Inertia の shared props 経由で受け取った locale 辞書から、ドット記法でテキストを引く軽量ヘルパ。
// 文言のハードコード禁止（CLAUDE.md 参照）。React 側でも必ずこの関数を経由する。

export type LocaleDict = Record<string, unknown>;

function lookup(dict: LocaleDict, path: string): string | undefined {
  return path.split(".").reduce<unknown>((acc, key) => {
    if (acc && typeof acc === "object" && key in (acc as Record<string, unknown>)) {
      return (acc as Record<string, unknown>)[key];
    }
    return undefined;
  }, dict) as string | undefined;
}

function interpolate(template: string, params: Record<string, string | number>): string {
  return template.replace(/%\{(\w+)\}/g, (_, key) => {
    const v = params[key];
    return v === undefined ? `%{${key}}` : String(v);
  });
}

export function createT(dict: LocaleDict) {
  return function t(key: string, params: Record<string, string | number> = {}): string {
    const found = lookup(dict, key);
    if (typeof found !== "string") {
      // 開発時に欠落を素早く気付けるよう、キーをそのまま返す
      return key;
    }
    return interpolate(found, params);
  };
}

/**
 * Optional lookup. Returns the localized string, or `undefined` if the key does not exist.
 * Use this when the locale value is optional (e.g. an AIO finding's `example` code snippet).
 */
export function createTOptional(dict: LocaleDict) {
  return function tOptional(key: string): string | undefined {
    const found = lookup(dict, key);
    return typeof found === "string" ? found : undefined;
  };
}
